import React from "react";
import './emptystate.css'


export function EmptyState({icon, className, title, content, doNotUseButton, buttonText, buttonOnClick}) {

    return (
        <div>
            <div className={`empty-state-card ${className || ''}`}>
                <div className={'empty-state-icon'}>
                    {icon}
                </div>
                <div className={`empty-state-title gray`}>{title}</div>
                <p className={`empty-state-content gray`}>
                    {content}
                </p>
                {
                    doNotUseButton ? '' :
                        <button className={'empty-state-button'} size="sm" type="submit" onClick={buttonOnClick}>
                            {buttonText}
                        </button>
                }
            </div>
        </div>
    )
}
